// /$$
//  $ @Author: 单译 2694138418@qq.com
//  $ @Date: 2022-11-23 12:38:07
//  $ @LastEditors: 单译 2694138418@qq.com
//  $ @LastEditTime: 2022-11-23 12:38:13
//  $ @FilePath: \music\src\assets\js\locale\cn.js
//  $ @Description: 
//  $ @
//  $ @Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
//  $/
export default {
    el: {
        table: {
        emptyText: '暂无数据',
        confirmFilter: '筛选',
        resetFilter: '重置',
        clearFilter: '全部',
        sumText: '合计'
      },
      pagination: {
        goto: '到第',
        pagesize: '条/页',
        total: `共 {total} 页`,
        pageClassifier: '页'
      }
    }
  };
  